import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const RamenIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#be250f';
  return <Icon name={'support-ramen'} size={size} color={color} />;
};

export default React.memo(RamenIcon);
